import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  exChangeRateAPI,
  getCategories,
  getOrderDetailAPI,
  getOrdersAPI,
  getProductDetailAPI,
  getShipping,
  getThemes,
  searchProductAPI,
} from './thunk';

export const initialState = {
  search: '',
  provider: 'TAOBAO',
  products: [],
  exChangeRate: 0,
  orders: [],
  orderDetail: {},
  productDetail: {},
  categories: [],
  themes: [],
  shipping: {},
  sellers: [],
  productList: [],
  errors: {},
};

const EcommerceSlice = createSlice({
  name: 'ecommerce',
  initialState,
  reducers: {
    updateProvider: (state, action: PayloadAction<string>) => {
      state.provider = action.payload;
    },
    updateSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    resetProducts: (state) => {
      state.products = [];
    },
  },
  extraReducers: (builder) => {
    // Orders
    builder.addCase(searchProductAPI.fulfilled, (state: any, action: any) => {
      state.products = [...state.products, ...(action.payload?.featured || []), ...(action.payload?.upstream || [])];
    });
    builder.addCase(exChangeRateAPI.fulfilled, (state: any, action: any) => {
      state.exChangeRate = action.payload.CNY_USD;
    });
    builder.addCase(
      getProductDetailAPI.fulfilled,
      (state: any, action: any) => {
        state.productDetail = action.payload;
      }
    );
    builder.addCase(getOrdersAPI.fulfilled, (state: any, action: any) => {
      state.orders = action.payload;
    });
    builder.addCase(getOrderDetailAPI.fulfilled, (state: any, action: any) => {
      state.orderDetail = action.payload;
    });
    builder.addCase(getCategories.fulfilled, (state: any, action: any) => {
      state.categories = action.payload;
    });
    builder.addCase(getThemes.fulfilled, (state: any, action: any) => {
      state.themes = action.payload;
    });
    builder.addCase(getShipping.fulfilled, (state: any, action: any) => {
      state.shipping = action.payload;
    });
  },
});

export const { updateSearch, updateProvider, resetProducts } =
  EcommerceSlice.actions;

export default EcommerceSlice.reducer;
